import React from "react"
import { Link } from "gatsby"
import data from "../../../content/casinos.json"
import { StaticImage } from "gatsby-plugin-image"
import "./header.scss"


class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      value: ''
    };

    this.handleChange = this.handleChange.bind(this);
  }

  toggleDropdown = () => {
    this.setState(prevState => ({
      active: !prevState.active
    }));
  }

  toggleSearch = () => {
    this.setState(prevState => ({
      searchActive: !prevState.searchActive
    }));
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  render() {
    return (
      <header className="site-header">
        <div className="wrapper">

          {!this.state.active ? (
            <span onClick={this.toggleDropdown} onKeyDown={this.toggleDropdown} tabIndex="0" role="button" aria-pressed="false" className="hamburger-button">Meny</span>
          ) : (
            <span onClick={this.toggleDropdown} onKeyDown={this.toggleDropdown} tabIndex="0" role="button" aria-pressed="false" className="hamburger-button active">Stäng</span>
          )}

          {/* MOBILE */}
          {this.state.active &&
            <nav role="navigation" itemScope itemType="https://schema.org/SiteNavigationElement">
              <ul className="hb-navigation">
                <li>
                  <Link itemProp="url" to="/" className="top-menu" activeClassName="active"><span itemProp="name">Bästa casino</span></Link>
                </li>

                <li><Link itemProp="url" to="/nya-casino/" className="top-menu" activeClassName="active"><span itemProp="name">Nya casinon</span></Link></li>

                <li>
                  <Link itemProp="url" to="/svenska-casino/" className="top-menu" activeClassName="active"><span itemProp="name">Alla casino</span></Link>
                  <ul className="dropdown">
                    <li><Link itemProp="url" to="/casino-snabba-uttag/" activeClassName="active"><span itemProp="name">Casino med snabba uttag</span></Link></li>
                    <li><Link itemProp="url" to="/casino-med-swish/" activeClassName="active"><span itemProp="name">Casino med Swish</span></Link></li>
                    <li><Link itemProp="url" to="/casino-med-bankid/" activeClassName="active"><span itemProp="name">Casino med BankID</span></Link></li>
                    <li><Link itemProp="url" to="/casino-utan-registrering/" activeClassName="active"><span itemProp="name">Casino utan registrering</span></Link></li>
                    <li><Link itemProp="url" to="/pay-n-play-casino/" activeClassName="active"><span itemProp="name">Pay n Play</span></Link></li>
                    <li><Link itemProp="url" to="/mobilcasino/" activeClassName="active"><span itemProp="name">Mobilcasino</span></Link></li>
                    <li><Link itemProp="url" to="/casinosidor/" activeClassName="active"><span itemProp="name">Casinosidor</span></Link></li>
                    <li><Link itemProp="url" to="/spelbolag/" activeClassName="active"><span itemProp="name">Spelbolag</span></Link></li>
                  </ul>
                </li>

                <li>
                  <Link itemProp="url" to="/casino-bonusar/" className="top-menu" activeClassName="active"><span itemProp="name">Casino Bonusar</span></Link>
                  <ul className="dropdown">
                    <li><Link itemProp="url" to="/freespins/" activeClassName="active"><span itemProp="name">Free Spins</span></Link></li>
                    <li><Link itemProp="url" to="/casino-bonusar/utan-omsattningskrav/" activeClassName="active"><span itemProp="name">Utan omsättningskrav</span></Link></li>
                    <li><Link itemProp="url" to="/casino-bonusar/utan-insattning/" activeClassName="active"><span itemProp="name">Registreringsbonus</span></Link></li>
                  </ul>
                </li>

                <li><Link itemProp="url" to="/recensioner/" className="top-menu" activeClassName="active"><span itemProp="name">Recensioner</span></Link></li>
              </ul>
            </nav>
          }

          {/* DESKTOP */}
          <div className="logo">
            <Link to="/" aria-label="Alcasino.se">
              <StaticImage src="../../images/alcasino.png" alt="Alcasino" placeholder="none" quality={100} />
            </Link>
          </div>

          <nav className="navigation" role="navigation" itemScope itemType="https://schema.org/SiteNavigationElement">
            <ul className="menu">
              <li className="menu-item">
                <Link itemProp="url" to="/" activeClassName="active"><span itemProp="name">Bästa casino</span></Link>
              </li>

              <li className="menu-item"><Link itemProp="url" to="/nya-casino/" activeClassName="active"><span itemProp="name">Nya casinon</span></Link></li>

              <li className="menu-item wd">
                <Link itemProp="url" to="/svenska-casino/" activeClassName="active"><span itemProp="name">Alla casino</span></Link>
                <ul className="dropdown">
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/casino-snabba-uttag/" activeClassName="active"><span itemProp="name">Casino med snabba uttag</span></Link></li>
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/casino-med-swish/" activeClassName="active"><span itemProp="name">Casino med Swish</span></Link></li>
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/casino-med-bankid/" activeClassName="active"><span itemProp="name">Casino med BankID</span></Link></li>
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/casino-utan-registrering/" activeClassName="active"><span itemProp="name">Casino utan registrering</span></Link></li>
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/pay-n-play-casino/" activeClassName="active"><span itemProp="name">Pay n Play</span></Link></li>
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/mobilcasino/" activeClassName="active"><span itemProp="name">Mobilcasino</span></Link></li>
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/casinosidor/" activeClassName="active"><span itemProp="name">Casinosidor</span></Link></li>
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/spelbolag/" activeClassName="active"><span itemProp="name">Spelbolag</span></Link></li>
                </ul>
              </li>

              <li className="menu-item wd">
                <Link itemProp="url" to="/casino-bonusar/" activeClassName="active"><span itemProp="name">Bonusar</span></Link>
                <ul className="dropdown">
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/freespins/" activeClassName="active"><span itemProp="name">Free Spins</span></Link></li>
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/casino-bonusar/utan-omsattningskrav/" activeClassName="active"><span itemProp="name">Utan omsättningskrav</span></Link></li>
                  <li className="menu-item sub-menu"><Link itemProp="url" to="/casino-bonusar/utan-insattning/" activeClassName="active"><span itemProp="name">Registreringsbonus</span></Link></li>
                </ul>
              </li>

              <li className="menu-item"><Link itemProp="url" to="/recensioner/" activeClassName="active"><span itemProp="name">Recensioner</span></Link></li>
            </ul>
          </nav>

          <div className="search">
            {!this.state.searchActive ? (
              <span className="search-button" onClick={this.toggleSearch} onKeyDown={this.toggleSearch} tabIndex="0" role="button" aria-pressed="false">Sök</span>
            ) : (
              <span className="search-button active" onClick={this.toggleSearch} onKeyDown={this.toggleSearch} tabIndex="0" role="button" aria-pressed="false">Stäng</span>
            )}

            {this.state.searchActive && (
              <div className="search-box">
                <input type="text" placeholder="Sök casino..." value={this.state.value} onChange={this.handleChange} />

                <div className="search-results">
                  {data.filter((val) => {
                    if (this.state.value === "" || this.state.value.length === 1 || this.state.value.length === 2) {
                      return false;
                    } else if (val.name.toLocaleLowerCase().includes(this.state.value.toLocaleLowerCase())) {
                      return val.name;
                    }
                    return false;
                  }).map((val, key) => {
                    return <Link key={key} to={"/recensioner/" + val.id + "/"}>
                      {val.name}
                    </Link>
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
    )
  }
}

export default Header